import React from 'react';
import { Text } from '../Text';
import { SmallScreenHeading, StyledTableCell } from './Table.styles';
import { TableContext } from './Table.context';
export var TableCell = React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      columnHeading = _ref.columnHeading,
      width = _ref.width,
      colSpan = _ref.colSpan,
      rowSpan = _ref.rowSpan;
  var tableContext = React.useContext(TableContext);
  return React.createElement(StyledTableCell, {
    ref: ref,
    role: "cell",
    width: width,
    colSpan: colSpan,
    rowSpan: rowSpan,
    hasSmallScreenHeading: Boolean(columnHeading),
    displayMode: tableContext.displayMode
  }, columnHeading ? React.createElement(SmallScreenHeading, {
    "aria-hidden": "true",
    displayMode: tableContext.displayMode
  }, React.createElement(Text, {
    as: "span",
    variant: "copy1",
    weight: "bold"
  }, columnHeading)) : null, children);
});
TableCell.displayName = 'TableCell';